module.exports = {"id":"183108","name":"Nordin Amrabat","rating":"79","photo":"./data/images/photos/2/183108.png","club":{"name":"CD Leganés","logo":"./data/images/clubs/CDLeganes.png"},"positions":["MD","MG","BU"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/NordinAmrabat0.json
// module id = 3239
// module chunks = 0